<template></template>
  
<script>
import IcFormsSent from "./Sent";
import IcSelect from "@/components/ic-common/form/controls/Select.vue";

export default {
  name: "IcFormsBase",
  data() {
    return {
      isSent: false,
      isError: false,
      errorMessage: "",
      sentData: {},
      group: "Complaint",
      selected: "",
      formType: [
        { value: "k01", name: this.$t("form_k01") },
        { value: "k02", name: this.$t("form_k02") },
        { value: "k03", name: this.$t("form_k03") },
        { value: "k04", name: this.$t("form_k04") },
        { value: "k05", name: this.$t("form_k05") },
        { value: "k06", name: this.$t("form_k06") },
        { value: "k07", name: this.$t("form_k07") },
        { value: "k08", name: this.$t("form_k08") },
        { value: "k09", name: this.$t("form_k09") },
        { value: "r07", name: this.$t("form_r07") },
        { value: "r01", name: this.$t("form_r01") },
        { value: "r08", name: this.$t("form_r08") },
        //{ value: "r10", name: this.$t("form_r10") },
        { value: "r02", name: this.$t("form_r02_kraj") },
        { value: "r02a", name: this.$t("form_r02_mn") },
        { value: "r03", name: this.$t("form_r03") },
        { value: "r04", name: this.$t("form_r04") },
        { value: "r05", name: this.$t("form_r05") },
        { value: "r09", name: this.$t("form_r09") },
        { value: "r06", name: this.$t("form_r06") }
      ]
    };
  },
  computed: {
    selectedComponent: function() {
      if (this.selected) {
        
        return "IcForm" + this.group + this.selected.toUpperCase();
      } else {
        return "";
      }
    },
    formName: function() {
      let form = this.formType.filter(v => v.value === this.selected);
      return form[0].name;
    },
    formTypeContact: function() {
      return this.formType.filter(v => v.value.indexOf("k") === 0);
    },
    formTypeComplaint: function() {
      return this.formType.filter(v => v.value.indexOf("r") === 0);
    }
  },
  methods: {
    sent: function(e) {
      this.isSent = true;
      this.sentData = e;
    },
    error: function(e) {
      this.isError = true;
      this.errorMessage = e;
    }
  },
  components: {
    IcFormsSent,
    IcSelect
  }
};
</script>

<style lang="scss">
.ic-forms {
  h3 {
    margin: 30px 0;
  }
  .has-error {
    label, p {
      color: #ed1c24;
    }
  }
}
</style>
